import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    Alert,
    AlertTitle,
    Button,
    ButtonBase,
    Paper,
    Stack,
    Typography,
} from '@material-ui/core'

import { Logo, LogoContainer } from '../Atoms'
import { getFullUrl } from '../../utils/UrlManipulation'

import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
    logo: {
        cursor: 'pointer',
        position: 'absolute',
        transform: `scale(0.34)`,
        transformOrigin: "top left",
        height: 250,
        width: 500,
        marginLeft: 24,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
        backgroundColor: 'white',
        zIndex: 1,
    },
    paper: {
        padding: 40,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '35vh',
        minHeight: 300,
        width: '50vw',
    },
    title: {},
    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '50%',
    }
}))

const ErrorPage = ({ error }) => {
    // This component can be reached from ErrorBoundary.js or when navigating to /error
    // When reached as a react component it will have the error prop, otherwise the data should be in the query parameters
    const { t } = useTranslation()
    const classes = useStyles()

    const { status, title, detail } = error

    return (
        <LogoContainer >
            <ButtonBase href='/' className={classes.logo} disableRipple disableTouchRipple>
                <Logo />
            </ButtonBase>
            <Stack direction="row" justifyContent='center' alignItems='center' style={{ height: "100vh" }}>
                <div className={classes.content}>
                    <Paper elevation={3} className={classes.paper}>
                        <Typography variant="h2" color="primary" className={classes.title}>
                            {t('error.title')}
                        </Typography>
                        <Alert severity="error">
                            <AlertTitle>{status} {title}</AlertTitle>
                            {detail}
                        </Alert>
                        <div className={classes.buttons}>
                            <Button variant="contained" color="primary" href='/'>{t('error.goHome')}</Button>
                            <Button variant="outlined" color="primary" href={getFullUrl()}>{t('error.tryAgain')}</Button>
                        </div>
                    </Paper>
                </div>
            </Stack>
        </LogoContainer>
    )
}


export default ErrorPage